import { render } from "./Product.vue?vue&type=template&id=82b53894&scoped=true&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=82b53894&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b53894"]])

export default __exports__